export default __webpack_public_path__ + "static/media/casual-treatment.4ae1cd84.jpg";